import { TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { wait } from "@msuite/utils/misc";
import type { AddressFormSchema } from "@msuite/utils/schemas";
import React from "react";
import { useFormContext } from "react-hook-form";
import { getCity } from "@/api/addresses";

export function AddressForm() {
	/** Context */
	const methods = useFormContext<AddressFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Functions */
	async function handleOnZipCodeBlur(count = 0) {
		try {
			if (count > 3) return null;
			const input = methods.getValues("zipCode");
			const currentCity = methods.getValues("city");
			if (currentCity) return;
			const city = await getCity(input);
			if (!city) return null;
			const noteRef = document.getElementsByName("note")?.[0] as HTMLInputElement;
			if (currentCity) return;
			methods.setValue("city", city);
			noteRef.focus();
		} catch {
			wait(200 * count);
			handleOnZipCodeBlur(count + 1);
		}
	}

	/** Render */
	return (
		<React.Fragment>
			<div className="gap-6 grid grid-cols-3 w-full">
				<div className="col-span-2">
					<TextInput
						isRequired
						label={t("address.street")}
						placeholder="Schillerstraße"
						control={methods.control}
						name="streetName"
						data-cy="address-street-name-input"
					/>
				</div>
				<div className="col-span-1">
					<TextInput
						label={t("address.house_number")}
						placeholder="13a"
						control={methods.control}
						name="houseNumber"
						isRequired={false}
						data-cy="address-house-number-input"
					/>
				</div>
			</div>
			<div className="gap-6 grid grid-cols-3 w-full">
				<div className="col-span-1">
					<TextInput
						isRequired
						label={t("address.zip_code")}
						placeholder="13158"
						control={methods.control}
						name="zipCode"
						onBlur={() => {
							handleOnZipCodeBlur();
						}}
						data-cy="address-zip-code-input"
					/>
				</div>
				<div className="col-span-2">
					<TextInput
						isRequired
						label={t("address.city")}
						placeholder="Berlin"
						control={methods.control}
						name="city"
						data-cy="address-city-input"
					/>
				</div>
			</div>
		</React.Fragment>
	);
}
